import { APP_NAME } from '../../config/appConfig';

interface TextLogoProps {
  variant?: 'full' | 'compact';
  className?: string;
}

const COMPACT_LABEL = APP_NAME
  .split(' ')
  .map((word) => word[0])
  .join('')
  .slice(0, 2)
  .toUpperCase();

export function TextLogo({ variant = 'full', className = '' }: TextLogoProps) {
  if (variant === 'compact') {
    return (
      <span
        className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-500 text-xs font-bold text-white ${className}`}
        aria-label={APP_NAME}
      >
        {COMPACT_LABEL}
      </span>
    );
  }

  const [firstWord, ...rest] = APP_NAME.split(' ');
  const remainder = rest.join(' ');

  return (
    <span
      className={`inline-flex items-baseline gap-1 whitespace-nowrap font-bold tracking-tight ${className}`}
      aria-label={APP_NAME}
    >
      <span className="text-xl text-brand-500 dark:text-brand-400">{firstWord}</span>
      {remainder ? (
        <span className="text-xl text-gray-800 dark:text-white/90">{remainder}</span>
      ) : null}
    </span>
  );
}
